export function isClearButton(value: unknown) {
  // DatePicker is null and Select is undefined for clear button.
  return value === null || value === undefined;
}
